<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />

                <a-radio-group
                    v-model="audit_status"
                    button-style="solid"
                    @change="(e) => on_field_change(e.target.value, 'audit_status')"
                    class="item"
                >
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="0">待审核</a-radio-button>
                    <a-radio-button value="-1">已拒绝</a-radio-button>
                    <a-radio-button value="1">已同意</a-radio-button>
                </a-radio-group>

                <!-- <a-radio-group v-model="type" button-style="solid" @change="(e) => on_field_change(e.target.value, 'type')" class="item">
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="first">首款</a-radio-button>
                    <a-radio-button value="last">尾款</a-radio-button>
                    <a-radio-button value="other">其他</a-radio-button>
                </a-radio-group> -->
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索单号" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-tabs v-model="scope" @change="(e) => on_field_change(e, 'scope')">
                <a-tab-pane key="order_loan_deposit" tab="卖家预付定金"> </a-tab-pane>
                <a-tab-pane key="order_loan" tab="卖家款款"> </a-tab-pane>
                <a-tab-pane key="balance_refund" tab="余额退款"> </a-tab-pane>
                <a-tab-pane key="recharge" tab="客户充值"> </a-tab-pane>
            </a-tabs>

            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
            >
                <template slot="order" slot-scope="text">
                    <div class="order" v-if="text">
                        <div class="name">
                            <a style="display: block;" :href="`/order/${text.order_no}`" target="_blank">{{ text.order_no }}</a>
                        </div>

                        <div class="detail">
                            <a-icon type="icon icon-tree"></a-icon>

                            <div class="">订单总金额：¥{{ text.amount }}<br />已放款：¥{{ text.amount_loaned }}</div>
                        </div>
                    </div>
                </template>

                <!-- 截图 -->
                <template slot="screenshot" slot-scope="text">
                    <a v-if="text" :href="text" target="_blank">查看</a>
                </template>

                <!-- 状态 -->
                <template slot="audit_status" slot-scope="text, record">
                    <a-tag class="b-tag" v-if="text == 0">待审核</a-tag>
                    <a-tag color="green" class="b-tag" v-if="text == 1">已同意</a-tag>
                    <a-tag color="red" class="b-tag" v-if="text == -1">已拒绝</a-tag>
                </template>

                <!-- 申请人 -->
                <template slot="user" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.user ? record.user.name : "-" }}
                        </div>
                        <div class="b">
                            {{ moment(record.created_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>

                <!-- 处理人 -->
                <template slot="executor" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.executor ? record.executor.name : "-" }}
                        </div>
                        <div class="b" v-if="record.executed_at">
                            {{ moment(record.executed_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>

                <template slot="member" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>

                <template slot="user" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b" v-if="text.group">{{ text.group.name }}</div>
                    </div>
                </template>

                <template slot="remark" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">{{ text }}</div>
                        <div class="b reject-msg" v-if="record.reject_msg">
                            <a-icon type="exclamation-circle" style="margin-right:2px;" />{{ record.reject_msg }}
                        </div>
                    </div>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="action">
                        <a-popconfirm title="是否同意该申请？" ok-text="是" cancel-text="否" @confirm="on_ok(record)">
                            <a-button size="small" :disabled="!!record.audit_status">同意</a-button>
                        </a-popconfirm>
                        <a-divider type="vertical" />
                        <a-button type="danger" size="small" @click="on_reject(record)" :disabled="!!record.audit_status">拒绝</a-button>
                    </div>
                </template>
            </a-table>
        </div>
        <!-- 拒绝 -->
        <modal_reject :visible="visible_reject" @close="visible_reject = false" :record="selected_record" :callback="load" :scope="scope" />
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import modal_reject from "./modal_reject.vue";
    import column from "./column";
    import commonjs from "../mixins/common";

    export default {
        mixins: [common_pagination, commonjs],
        components: { modal_reject },
        data() {
            return {
                path: "/apply/audit",
                data_source: [],
                loading: false,
                selected_record: null,
                wd: null,
                visible_reject: false,
                type: "",
                scope: "",
                audit_status: "",
                columns: [],
            };
        },
        created() {
            this.$store.commit("change_state", {
                name: "sidebar_order",
                value: "approval_audit",
            });

            this.reset_query();
            this.load();
        },
        watch: {
            $route() {
                this.reset_query();
                this.load();
            },
            scope(e) {
                this.columns = column[e];
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                new_query["scope"] = this.scope;
                this.$http
                    .get(`/apply/audit?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };

                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            reset_query() {
                let query = this.$route.query;
                this.wd = "wd" in query ? query["wd"] : "";
                this.type = Object.prototype.hasOwnProperty.call(query, "type") ? query["type"] : "";
                this.scope = Object.prototype.hasOwnProperty.call(query, "scope") ? query["scope"] : "order_loan_deposit";

                this.audit_status = Object.prototype.hasOwnProperty.call(query, "audit_status") ? query["audit_status"] : "";
            },
            on_reject(item) {
                this.selected_record = item;
                this.visible_reject = true;
            },
            on_ok(item) {
                this.$http
                    .post(`/apply/audit/review`, { object_no: item.object_no, scope: this.scope, action: "ok" })
                    .then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                            this.load();
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        /deep/.ant-tabs-bar {
            margin: 0 !important;
        }
        .summary {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }

        .order {
            .name {
                font-size: 13px;
                margin-bottom: 2px;
            }
            .detail {
                font-size: 12px;
                color: #00000080;
                display: flex;
                > .anticon {
                    padding-top: 8px;
                }
            }
        }

        .reject-msg {
            color: #ff9800;
            font-size: 12px;
            .ph {
                height: 1px;
                width: 24px;
                background: #ff9800;
                margin-top: 4px;
                margin-bottom: 4px;
            }
        }
    }
</style>
